import { useMemo } from 'react'
import { paramsService } from '../services/paramsService'
import { MARKETING_SESSION_ID_COOKIE_KEY } from '../services/CookiesService'

export const useBwllMktSessionId = () => {
  return useMemo(() => paramsService.getParam(MARKETING_SESSION_ID_COOKIE_KEY) ?? null, [])
}
